export const LocationFilledIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M17.1849 7.04158C16.3099 3.19159 12.9515 1.45825 10.0015 1.45825C10.0015 1.45825 10.0015 1.45825 9.99321 1.45825C7.05154 1.45825 3.68488 3.18325 2.80988 7.03325C1.83488 11.3333 4.46821 14.9749 6.85154 17.2666C7.73488 18.1166 8.86821 18.5416 10.0015 18.5416C11.1349 18.5416 12.2682 18.1166 13.1432 17.2666C15.5265 14.9749 18.1599 11.3416 17.1849 7.04158ZM10.0015 11.2166C8.55154 11.2166 7.37654 10.0416 7.37654 8.59158C7.37654 7.14159 8.55154 5.96658 10.0015 5.96658C11.4515 5.96658 12.6265 7.14159 12.6265 8.59158C12.6265 10.0416 11.4515 11.2166 10.0015 11.2166Z"
        fill="currentColor"
      />
    </svg>
  )
}
